import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/QuoteSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/StorySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/TeamSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/TechnologySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/SectionErrorBoundary.tsx");
